import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "NavigateBack" }

import Icon from "@/components/ds/icon/Icon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'NavigateBack',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Icon, { "icon-id": "arrow-left" }),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})